import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../Admin1/Pages/admin1.css';
import heloicon from '../../../safreeimg/superadminimg/heloicon.png';
import axios from 'axios';
import Loader from '../../../safreeimg/loader.gif';
import 'react-phone-number-input/style.css';

const GuardianGroup = () => {
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const rowsPerPage = 10;
  const navigate = useNavigate();

  // Fetching data from the API
  const fetchData = async () => {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        setError('No authentication token found');
        setLoading(false);
        return;
      }

      const response = await axios.get(
        'https://api.safree.org/api-v2022/org-guardian/my/v1/my-groups',
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        setUsers(response.data.data);
      } else {
        setError('Failed to fetch users');
      }
    } catch (err) {
      console.error('Error fetching users:', err);
      setError('An error occurred while fetching users: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);



  const totalPages = Math.ceil(users.length / rowsPerPage);
  const currentRows = users.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handlePageChange = (direction) => {
    if (direction === 'prev' && currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
    if (direction === 'next' && currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const getPageNumbers = () => {
    const maxPageNumbersToShow = 5;
    const startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
    const endPage = Math.min(totalPages, startPage + maxPageNumbersToShow - 1);

    const pageNumbers = [];
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  const handleViewGroupDetail = (userId) => {
    navigate(`../guardianGroup/guardianGroupView/#${userId}`);
  };

  // const handleViewAlarms = (userId) => {
  //   navigate(`../guardianAlarms/#${userId}`);
  // };

  if (loading) return <div className="loading"><img src={Loader} alt="" /></div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="container user-management">
      <div className="row header">
        <div className="col-md-6">
          <p className="sub-heading">Group Management</p>
        </div>
       
      </div>

      <div className="table-container">
        <table className="styled-table">
          <thead>
            <tr>
              <th>S. No</th>
              <th>Group Name</th>
              <th>Description</th>
              <th>Group Details</th>
              {/* <th>Alarms</th> */}
            </tr>
          </thead>
          <tbody>
            {users.length === 0 ? (
              <tr>
                <td colSpan="5" style={{ textAlign: 'center', fontSize: '42px', color: '#f54138', fontWeight: 700  }}>No Data Found</td>
              </tr>
            ) : (
              currentRows.map((user, index) => (
                <tr key={index}>
                  <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                  <td>{user.name}</td>
                  <td>{user.description}</td>
                  <td>
                    <button
                      className="btn btn-view"
                      onClick={() => handleViewGroupDetail(user.groupId)}
                    >
                      View Details
                    </button>
                  </td>
                  {/* <td>
                    <button
                      className="btn btn-view"
                      onClick={() => handleViewAlarms(user.groupId)}
                    >
                      View Details
                    </button>
                  </td> */}
                </tr>
              ))
            )}
          </tbody>
        </table>

        <div className="pagination-container">
          <button
            className="pagination-btn"
            onClick={() => handlePageChange('prev')}
            disabled={currentPage === 1}
          >
            &laquo; Prev
          </button>
          {getPageNumbers().map((page) => (
            <button
              key={page}
              className={`pagination-btn ${currentPage === page ? 'active' : ''}`}
              onClick={() => setCurrentPage(page)}
            >
              {page}
            </button>
          ))}
          <button
            className="pagination-btn"
            onClick={() => handlePageChange('next')}
            disabled={currentPage === totalPages}
          >
            Next &raquo;
          </button>
        </div>
      </div>
    </div>
  );
};

export default GuardianGroup;
